<template>
  <FileUploader :text="'Смяна на снимката'" :allowedFiles="'image/jpeg, image/png'" @file-upload="uploadImage"/>
</template>

<script>
    import FileUploader from "@/shared/components/form/FileUploader";

    export default {
        name: 'ImageUploader',
      components: {FileUploader},
      data() {
            return {
                image: null
            }
        },
        methods: {
            uploadImage(image) {
                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e => {
                    this.image = e.target.result;
                };
            }
        },
        watch: {
            image: {
                handler() {
                    this.$emit('image-upload', this.image);
                },
                deep: true
            }
        }
    }
</script>

<style>
</style>
